<template>
  <v-card>
    <v-card-text class="pa-0">
      <v-container fluid grid-list-lg :style="{ width: '100% !important' }">
        <v-layout wrap>
          <v-flex class="default-input" xs12 md4>
            <div class="caption">Agent</div>
            <v-text-field
              v-model="localValue.agent"
              hide-details
              outline
              single-line
              placeholder="Agent"
            ></v-text-field>
          </v-flex>
          <v-flex class="default-input" xs12 md4>
            <div class="caption">Ticket ID.</div>
            <v-text-field
              v-model="localValue.ticket_id"
              hide-details
              outline
              single-line
              placeholder="Ticket no."
            ></v-text-field>
          </v-flex>
          <v-flex class="default-input-textfield" xs12 md4>
            <div class="caption">NPS</div>
            <v-select
              v-model="localValue.nps_score"
              hide-details
              outline
              single-line
              :items="scoreOptions"
              placeholder="NPS"
            >
            </v-select>
          </v-flex>
          <v-flex class="default-input-textfield" xs12 md4>
            <div class="caption">OSAT</div>
            <v-select
              v-model="localValue.osat_score"
              hide-details
              outline
              single-line
              :items="scoreOptions"
              placeholder="OSAT"
            ></v-select>
          </v-flex>
          <v-flex class="default-input" xs12 md4>
            <div class="caption">Survey sent From</div>
            <DatePickerWithoutButton v-model="localValue.survey_sent_from">
              <v-text-field
                class="custom-datepicker-input"
                hide-details
                outline
                readonly
                single-line
                prepend-inner-icon="calendar_month"
                :value="toFormattedDate(localValue.survey_sent_from)"
                placeholder="DD/MM/YYYY"
              ></v-text-field>
            </DatePickerWithoutButton>
          </v-flex>
          <v-flex class="default-input" xs12 md4>
            <div class="caption">Survey sent to</div>
            <DatePickerWithoutButton v-model="localValue.survey_sent_to">
              <v-text-field
                class="custom-datepicker-input"
                hide-details
                outline
                readonly
                single-line
                prepend-inner-icon="calendar_month"
                :value="toFormattedDate(localValue.survey_sent_to)"
                placeholder="DD/MM/YYYY"
              ></v-text-field>
            </DatePickerWithoutButton>
          </v-flex>
          <v-flex class="default-input" xs12 md4>
            <div class="caption">Survey submit from</div>
            <DatePickerWithoutButton v-model="localValue.survey_submit_from">
              <v-text-field
                class="custom-datepicker-input"
                hide-details
                outline
                readonly
                single-line
                prepend-inner-icon="calendar_month"
                :value="toFormattedDate(localValue.survey_submit_from)"
                placeholder="DD/MM/YYYY"
              ></v-text-field>
            </DatePickerWithoutButton>
          </v-flex>
          <v-flex class="default-input" xs12 md4>
            <div class="caption">Survey submit to</div>
            <DatePickerWithoutButton v-model="localValue.survey_submit_to">
              <v-text-field
                class="custom-datepicker-input"
                hide-details
                outline
                readonly
                single-line
                prepend-inner-icon="calendar_month"
                :value="toFormattedDate(localValue.survey_submit_to)"
                placeholder="DD/MM/YYYY"
              ></v-text-field>
            </DatePickerWithoutButton>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>

    <v-card-actions class="px-4 pb-4" style="display: flex; justify-content: flex-end">
      <v-btn outline color="grey" class="mr-2" @click="handleClearSearchButtonClick">{{
        $t('Clear Search')
      }}</v-btn>
      <v-btn depressed color="primary" @click="handleSearchButtonClick">
        <em class="fas fa-search mr-1" />
        {{ $t('Search') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import moment from 'moment'
import { DATETIME } from '@/constants/datetime'
import { TTB_PAGE_LIST, TTB_CHANNEL_LIST } from '@/constants/ttb'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'

export default {
  components: {
    DatePickerWithoutButton
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      localValue: {
        agent: null,
        ticket_id: null,
        nps_score: null,
        osat_score: null,
        survey_sent_from: null,
        survey_sent_to: null,
        survey_submit_from: null,
        survey_submit_to: null,
        ...this.value
      },
      pageOptions: [{ value: '', text: 'All' }, ...TTB_PAGE_LIST],
      channelOptions: [{ value: '', text: 'All' }, ...TTB_CHANNEL_LIST]
    }
  },
  computed: {
    scoreOptions() {
      return Array.from({ length: 5 }, (_, i) => i + 1)
    }
  },
  watch: {
    value(value) {
      this.localValue = { ...value }
    }
  },
  methods: {
    handleClearSearchButtonClick() {
      this.$emit('input', {
        agent: null,
        ticket_id: null,
        nps_score: null,
        osat_score: null,
        survey_sent_from: null,
        survey_sent_to: null,
        survey_submit_from: null,
        survey_submit_to: null
      })
      this.$emit('onSearch')
    },
    handleSearchButtonClick() {
      this.$emit('input', { ...this.localValue })
      this.$emit('onSearch')
    },
    toFormattedDate(value) {
      if (!value) return ''
      return moment(value).format(DATETIME.DATE_FORMAT_DISPLAY)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/features/ttb/DashboardNonvoice/Survey/AdvancedSearch.vue